import React, { CSSProperties, ReactNode } from 'react'
import { constants } from '../../Constants'
import { Alignment } from '../../storage/Debugging'

export interface RectProps {
    x: number
    y: number
    width: number
    height: number
    cursor?: string
    rectColor?: string
    rectBorderColor?: string
    rectBorderWidth?: number,
    onClick?: (e: any) => void
    labelAlign: Alignment
    children?: ReactNode,
    styles?: CSSProperties,
}

export const D3Rect: React.FC<RectProps> = ({ x, y, width, height, cursor, rectColor, rectBorderColor, rectBorderWidth, children, onClick, styles, labelAlign }) => {

    const { BLOCK } = constants

    return (<g onClick={onClick} cursor={cursor || 'auto'}>
        <rect
            x={x} y={y}
            width={width} height={height}
            fill={rectColor || 'green'}
            stroke={rectBorderColor || 'transparent'}
            strokeWidth={rectBorderWidth || 0}
            style={styles}
        >
        </rect>
        <foreignObject x={x} y={y} width={BLOCK.WIDTH} height={BLOCK.HEIGHT}>
            <D3RectLabel children={children} labelAlign={labelAlign} />
        </foreignObject>
    </g>
    )
}



export const D3RectLabel = (props: { children: React.ReactNode, labelAlign: Alignment }) => {

    const style: CSSProperties = {
        fontSize: '12px',
        height: '100%',
        display: 'flex',
        justifyContent: props.labelAlign,
        alignItems: 'center',
        textAlign: props.labelAlign,
        paddingRight: '10px',
        paddingLeft: '10px',
    }

    return (
        <div {...{ style }}>{props.children}</div>
    )
}